/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { Typography, Box, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';

import moment from 'moment';

import { useSelector, connect } from 'react-redux';

import colors from '../../../constants/colors';
import { getMonday, getSunday } from '../../../utils/dates';
import DateRangePicker from '../../DateRangePicker/DateRangePicker';
import DateRangeCBI from '../../components/ClearBI/DateRangeCBI';
import { setSelectedDateRange, setSelectedDateRangePicker } from '../../../store/actions/Alerts/action';

import { TODAY, THIS_WEEK, CUSTOM } from '../../../constants/dateRanges';
import { MY_TEAM } from '../../../constants/teamNames';
import AlertType from '../../../constants/alertType';
import CurrentContext from '../../../context/current-context';

const useStyles = makeStyles(() => ({
  container: {
    background: 'Transparent',
    display: 'flex',
    gap: '10px',
    marginBottom: '8px',
    marginTop: '4px',
  },
  root: {
    height: '200px',
    flex: '1 1 0',
    minWidth: '160px',
    background: '#ffffff',
    boxShadow: (selectedTeam) => (selectedTeam
      ? 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px, rgb(0 0 0 / 22%) 0px 25.6px 57.6px'
      : ''),
    borderRadius: '4px',
    display: 'block',
    '&:hover': {
      backgroundColor: (selectedTeam) => (selectedTeam ? colors.blue : '#ffffff'),
      boxShadow: (selectedTeam) => (selectedTeam
        ? ''
        : 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px, rgb(0 0 0 / 22%) 0px 25.6px 57.6px'),
    },
    cursor: 'pointer',
  },
  rootSelected: {
    height: '200px',
    flex: '1 1 0',
    minWidth: '160px',
    background: colors.blue,
    boxShadow: 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px, rgb(0 0 0 / 22%) 0px 25.6px 57.6px',
    borderRadius: '4px',
    display: 'block',
    '&:hover': {
      backgroundColor: colors.blue,
      color: colors.white,
    },
    cursor: 'pointer',
  },
  rootDisabled: {
    height: '200px',
    flex: '1 1 0',
    minWidth: '160px',
    background: 'transparent',
  },
  alert: {
    height: '200px',
    flex: '1 1 0',
    minWidth: '160px',
    background: '#F8F8F8',
    boxShadow:
      '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    borderRadius: '4px',
    cursor: 'pointer',
    overflow: 'auto',
  },
  heading: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '500',
    marginTop: '55px',
    textAlign: 'center',
    fontSize: '32px',
    color: colors.grey,
    lineHeight: 1.4,
  },
  headingSelected: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '500',
    marginTop: '55px',
    textAlign: 'center',
    fontSize: '32px',
    color: colors.white,
    lineHeight: 1.4,
  },
  alertHeading: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: 'normal',
    marginTop: '15px',
    fontSize: '14px',
    textAlign: 'left',
    marginLeft: '10px',
    color: (selectedTeam) => (selectedTeam ? colors.white : colors.grey),
    lineHeight: 1.5,
  },
  alertHeadingSelected: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    textAlign: 'left',
    color: (selectedTeam) => (selectedTeam ? colors.white : colors.grey),
    lineHeight: 1.5,
    overflow: 'hidden',
  },
  alertRow: {
    marginBottom: '10px',
  },
  alertIcon: {
    borderRadius: '50%',
    padding: '3px 3px 3px 3px', // rounded count of alerts
    backgroundColor: '#200E32',
    border: '1px solid #000',
    color: colors.white,
    marginRight: '15px',
  },
  editIcon: {
    marginLeft: '10px',
  },
  headingTitle: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '12px',
    color: (selectedTeam) => (selectedTeam ? colors.white : colors.grey),
    lineHeight: 1.5,
  },
  headingTitleSelected: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '12px',
    color: colors.white,
    lineHeight: 1.5,
  },
  headingDetails: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '500',
    textAlign: 'center',
    fontSize: '12px',
    marginTop: '3px',
    color: (selectedTeam) => (selectedTeam ? colors.white : colors.grey),
    lineHeight: 1.5,
  },
  headingDetailsSelected: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '500',
    textAlign: 'center',
    fontSize: '12px',
    marginTop: '3px',
    color: colors.white,
    lineHeight: 1.5,
  },
  headingDetailsCustom: {},
  headingDetailsCustomSelected: {
    color: colors.white,
  },
  daterangepicker: {
    background: 'Transparent',
    border: 'none',
    color: 'rgb(140, 140, 139)',
    borderRadius: '3px',
    marginTop: '3px',
    outline: '0',
    fontSize: '12px',
    fontStyle: 'normal',
    textAlign: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:active': {
      background: 'Transparent',
    },
  },
  daterangepickerSelected: {
    background: 'Transparent',
    border: 'none',
    borderRadius: '3px',
    marginTop: '3px',
    outline: '0',
    fontSize: '12px',
    fontStyle: 'normal',
    textAlign: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:active': {
      background: 'Transparent',
    },
  },
  skeleton: {
    display: 'block',
    flex: '1 1 0',
    minWidth: '160px',
    borderRadius: '4px',
  }
}));

const $FIXEDWIDTH = 236;
const $FIXEDHEIGHT = 236;

const TeamDates = ({
  setSelectedDateRange,
  setSelectedDateRangePicker,
  onChangeDates,
  selectedTeamName,
}) => {
  const value = useContext(CurrentContext);

  const classes = useStyles('');

  const selectedDateRange = useSelector((state) => state.Alerts.selectedDateRange);
  const counts = useSelector((state) => state.Alerts);
  const selectedAlertType = useSelector((state) => state.Alerts.selectedAlert);
  const selectedDateRangePicker = useSelector((state) => state.Alerts.selectedDateRangePicker);

  const [todayAlerts, setTodayAlerts] = useState(counts.myTeamTodayCounts);
  const [thisWeekAlerts, setThisWeekAlerts] = useState(counts.myTeamThisWeekCounts);
  const [customAlerts, setCustomAlerts] = useState(counts.myTeamCustomCounts);
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);

  const [todayAlertsCount, setTodayAlertsCount] = useState(0);
  const [thisWeekAlertsCount, setThisWeekAlertsCount] = useState(0);
  const [customAlertsCount, setCustomAlertsCount] = useState(0);

  const handleDateRangePicker = async (startDate, finishDate) => {
    setSelectedDateRangePicker([startDate, finishDate]);
    onChangeDates([startDate, finishDate]);
  };
  const handleCalendar = () => {
    if (selectedDateRange === CUSTOM) {
      setIsOpenCalendar(!isOpenCalendar);
    }
  };

  useEffect(() => {
    if (counts) {
      if (selectedTeamName === MY_TEAM) {
        setTodayAlertsCount(counts.myTeamTodayCounts.reduce((acc, cur) => acc + cur.count, 0));
        setThisWeekAlertsCount(
          counts.myTeamThisWeekCounts.reduce((acc, cur) => acc + cur.count, 0),
        );
        setCustomAlertsCount(counts.myTeamCustomCounts.reduce((acc, cur) => acc + cur.count, 0));
        setTodayAlerts(counts.myTeamTodayCounts);
        setThisWeekAlerts(counts.myTeamThisWeekCounts);
        setCustomAlerts(counts.myTeamCustomCounts);
      } else {
        setTodayAlertsCount(counts.otherTeamsTodayCounts.reduce((acc, cur) => acc + cur.count, 0));
        setThisWeekAlertsCount(
          counts.otherTeamsThisWeekCounts.reduce((acc, cur) => acc + cur.count, 0),
        );
        setCustomAlertsCount(
          counts.otherTeamsCustomCounts.reduce((acc, cur) => acc + cur.count, 0),
        );
        setTodayAlerts(counts.otherTeamsTodayCounts);
        setThisWeekAlerts(counts.otherTeamsThisWeekCounts);
        setCustomAlerts(counts.otherTeamsCustomCounts);
      }
    }
  }, [selectedTeamName, counts] || []);
  useEffect(() => {
    if (isOpenCalendar) {
      setIsOpenCalendar(false);
    }
  }, [selectedTeamName, selectedDateRange]);

  const SkeletonLayout = (type) => {
    if (type === AlertType.performance) {
      return (
      <> 
        <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} /> 
        <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} /> 
        <Box className={classes.rootDisabled} />
      </>)
    }
    return (
      <>
        <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} /> 
        <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} /> 
        <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} /> 
      </>
    )
  }

  const today = new Date();
  const monday = moment(getMonday(today)).format('YYYY-MM-DD');
  const sunday = moment(getSunday(today)).format('YYYY-MM-DD');

  return (
    <>
      <Box className={classes.container}>
        {value ? SkeletonLayout(selectedAlertType)
        : <>
          <Box
            className={
              selectedDateRange === TODAY ? classes.rootSelected : classes.root
            }
            onClick={() => setSelectedDateRange(TODAY)}
          >
            <Typography
              variant="h5"
              className={
                selectedDateRange === TODAY
                  ? classes.headingSelected
                  : classes.heading
              }
            >
              {todayAlertsCount}
            </Typography>
            <Typography
              variant="h6"
              className={
                selectedDateRange === TODAY
                  ? classes.headingTitleSelected
                  : classes.headingTitle
              }
            >
              Today
            </Typography>
            <Typography
              variant="h6"
              className={
                selectedDateRange === TODAY
                  ? classes.headingDetailsSelected
                  : classes.headingDetails
              }
            >
              <DateRangeCBI startDate={moment(today).format('YYYY-MM-DD')} />
            </Typography>
          </Box>
          { selectedAlertType ===  AlertType.schedule ?
            <>
              <Box
                className={
                  selectedDateRange === THIS_WEEK
                    ? classes.rootSelected
                    : classes.root
                }
                onClick={() => setSelectedDateRange(THIS_WEEK)}
              >
                <Typography
                  variant="h5"
                  className={
                    selectedDateRange === THIS_WEEK
                      ? classes.headingSelected
                      : classes.heading
                  }
                >
                  {thisWeekAlertsCount}
                </Typography>
                <Typography
                  variant="h6"
                  className={
                    selectedDateRange === THIS_WEEK
                      ? classes.headingTitleSelected
                      : classes.headingTitle
                  }
                >
                  This Week
                </Typography>
                <Typography
                  variant="h6"
                  className={
                    selectedDateRange === THIS_WEEK
                      ? classes.headingDetailsSelected
                      : classes.headingDetails
                  }
                >
                  <DateRangeCBI startDate={monday} endDate={sunday} />
                </Typography>
              </Box>
              <Box
                className={
                  selectedDateRange === CUSTOM ? classes.rootSelected : classes.root
                }
                onClick={() => setSelectedDateRange(CUSTOM)}
              >
                <Typography
                  variant="h5"
                  className={
                    selectedDateRange === CUSTOM
                      ? classes.headingSelected
                      : classes.heading
                  }
                >
                  {customAlertsCount}
                </Typography>
                <Typography
                  variant="h6"
                  className={
                    selectedDateRange === CUSTOM
                      ? classes.headingTitleSelected
                      : classes.headingTitle
                  }
                >
                  Custom
                </Typography>
                <Typography
                  variant="h6"
                  className={
                    selectedDateRange === CUSTOM
                      ? classes.headingDetailsSelected
                      : classes.headingDetails
                  }
                >
                  <DateRangeCBI
                    startDate={selectedDateRangePicker[0]}
                    endDate={selectedDateRangePicker[1]}
                    onClick={handleCalendar}
                  />
                </Typography>
              </Box>
            </>
            :
            <>
              <Box className={classes.rootDisabled} />
              <Box className={classes.rootDisabled} />
            </>
          }
        </>}
      </Box>
      <Box className={classes.container}>
        {value ? <>
          <Skeleton className={classes.skeleton} variant='rect' width={$FIXEDWIDTH} height={$FIXEDHEIGHT} />
          <Box className={classes.rootDisabled} />
          <Box className={classes.rootDisabled} />
        </>
        : <>
          <Box
            className={classes.alert}
            style={{
              visibility: selectedDateRange === TODAY ? 'visible' : 'hidden',
            }}
          >
            <Typography variant="h5" className={classes.alertHeading}>
              <Link
                key={TODAY}
                to={{
                  pathname: './TeamAlerts',
                  state: { redirected: true },
                }}
                style={{ textDecoration: 'none', color: 'rgb(140, 140, 139)' }}
              >
                { todayAlerts
                      && todayAlerts.map((a, index) => (
                        <div className={classes.alertRow} key={index}>
                          <span className={classes.alertIcon}>{a.count}</span>
                          {a.scheduleAlarmDescription}
                        </div>
                      ))}
              </Link>
            </Typography>
          </Box>
          <Box
            className={classes.alert}
            style={{
              visibility:
                    selectedDateRange === THIS_WEEK ? 'visible' : 'hidden',
            }}
          >
            <Typography variant="h5" className={classes.alertHeading}>
              <Link
                key={THIS_WEEK}
                to={{
                  pathname: './TeamAlerts',
                  state: { redirected: true },
                }}
                style={{ textDecoration: 'none', color: 'rgb(140, 140, 139)' }}
              >
                { thisWeekAlerts
                      && thisWeekAlerts.map((a, index) => (
                        <div className={classes.alertRow} key={index}>
                          <span className={classes.alertIcon}>{a.count}</span>
                          {a.scheduleAlarmDescription}
                        </div>
                      ))}
              </Link>
            </Typography>
          </Box>
          <Box
            className={classes.alert}
            style={{
              visibility: selectedDateRange === CUSTOM ? 'visible' : 'hidden',
            }}
          >
            <Typography variant="h5" className={isOpenCalendar ? classes.alertHeadingSelected : classes.alertHeading}>
              {isOpenCalendar
                ? (
                  <DateRangePicker
                    dates={selectedDateRangePicker}
                    handleDateRangePicker={handleDateRangePicker}
                    onClose={handleCalendar}
                  />
                )
                : (
                  <Link
                    key={CUSTOM}
                    to={{
                      pathname: './TeamAlerts',
                      state: { redirected: true },
                    }}
                    style={{ textDecoration: 'none', color: 'rgb(140, 140, 139)' }}
                  >
                    { customAlerts
                        && customAlerts.map((a, index) => (
                          <div className={classes.alertRow} key={index}>
                            <span className={classes.alertIcon}>{a.count}</span>
                            {a.scheduleAlarmDescription}
                          </div>
                        ))}
                  </Link>
                )}
            </Typography>
          </Box>
        </>}
      </Box>
    </>
  );
};

TeamDates.propTypes = {
  setSelectedDateRange: PropTypes.func.isRequired,
  setSelectedDateRangePicker: PropTypes.func.isRequired,
  onChangeDates: PropTypes.func.isRequired,
  selectedTeamName: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setSelectedDateRange(payload) {
    dispatch(setSelectedDateRange(payload));
  },
  setSelectedDateRangePicker(payload) {
    dispatch(setSelectedDateRangePicker(payload));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(TeamDates);
